import icons from "../assets/productsIcons/index";

class IconService {
  constructor() {
    this.icons = icons;
  }

  getIcons() {
    return this.icons;
  }

  getIcon(productName) {
    const icon = this.icons.find((i) => i.name === productName);
    return icon.icon;
  }
}

export default new IconService();
